export default {"src":"/_next/static/media/wallet-ethereum.f7bb39e9.svg","height":512,"width":320};